import styled, { css } from "styled-components";
import PropTypes from "prop-types";

import { SearchWrapper } from "core/SiteHeader/styles";
import breakpoints from "core/breakpoints";
import { spacingWithBreakpoints } from "core/spacing";

const heroContainerTabletLeftRightPadding = css`
    padding-left: 1.25rem; /* 20px */
    padding-right: 1.25rem; /* 20px */
`;

export const HeroContainer = styled.div`
    /* copied from SectionContainer: */
    margin: 0 auto;
    position: relative;
    width: 100%;
    max-width: 85.38rem; /* 1366px */

    ${spacingWithBreakpoints.XL4Bottom}

    /* Mobile: */
    padding-left: 0.9375rem; /* 15px */
    padding-right: 0.9375rem; /* 15px */

    /* Tablet: */
    @media (min-width: ${breakpoints.tablet.rem}) {
        ${heroContainerTabletLeftRightPadding};
    }

    /* Desktop: */
    @media (min-width: ${breakpoints.desktop.rem}) {
        padding-left: 1.5rem; /* 24px */
        padding-right: 1.5rem; /* 24px */
    }

    /* Screens with 700px - 1000px height range: */
    @media ${breakpoints.laptopHeightsRange.rem} {
        @media (min-width: ${breakpoints.desktop.rem}) {
            ${heroContainerTabletLeftRightPadding};
        }
    }

    .stuck-searchbar {
        display: none;
    }

    ${SearchWrapper} {
        margin: 0 auto;
        width: 100%;
        height: 2.5rem; /* 40px */

        > div {
            height: 100%;
        }

        form {
            height: 100%;
        }

        input[type="search"] {
            height: 100%;

            &,
            &:placeholder {
                font-size: 1.125rem; /* 18px */
            }
        }

        /* Tablet - Desktop: */
        @media (min-width: ${breakpoints.tablet
                .rem}) and (max-width: ${breakpoints.beforeDesktop.rem}) {
            max-width: 30rem; /* 30px */
        }

        /* Tablet +: */
        @media (min-width: ${breakpoints.tablet.rem}) {
            height: 4.235rem; /* 67.76px */
        }

        /* Desktop +: */
        @media (min-width: ${breakpoints.desktop.rem}) {
            max-width: 54.5rem; /* 872px */
        }
    }
`;
// ^^ Above spacing mimics default SectionContainer padding, but puts it inside a container inside the hero so the svg image at the bottom can reach the edges of the SectionContainer

export const IconsContainer = styled.div`
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 100%;

    /* Mobile: */
    height: ${({ mobileContainerHeight }) =>
        mobileContainerHeight ? `${mobileContainerHeight}px` : "147px"};
    background-image: url(${({ mobileSvgUrl }) => mobileSvgUrl});

    /* Tablet +: */
    @media (min-width: ${breakpoints.tablet.rem}) {
        height: ${({ desktopContainerHeight }) =>
            desktopContainerHeight ? `${desktopContainerHeight}px` : "229px"};

        background-image: url(${({ desktopSvgUrl }) => desktopSvgUrl});
    }
`;

IconsContainer.propTypes = {
    mobileSvgUrl: PropTypes.string,
    desktopSvgUrl: PropTypes.string,
    mobileContainerHeight: PropTypes.number,
    desktopContainerHeight: PropTypes.number
};

/* for HeroImage: */

export const HeroImg = styled.img`
    width: 100%;
    height: auto;
`;
